var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('citation-reference');
import { breakpoints, theme } from '@shapeable/theme';
import ReactTooltip from 'react-tooltip';
import { useEmbedsBySlug } from '../../hooks/use-embeds-by-slug';
import { useEntity } from '../../hooks/use-entity';
import { useTheme } from '../../hooks/use-theme';
import { useReady } from '../../hooks/use-ready';
import { CitationCell } from './citation-cell';
export var CitationReferenceDefaultProps = {}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n\n  "], ["\n    position: relative;\n\n  "])))
});
var TextStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 16px;\n    line-height: 1em;\n    position: relative;\n    top: -5px;\n    left: 2px;\n    margin-right: 1px;\n    cursor: pointer;\n    vertical-align: baseline;\n    width: ", ";\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    \n    &:hover {\n      border-color: ", ";\n    }\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 16px;\n    line-height: 1em;\n    position: relative;\n    top: -5px;\n    left: 2px;\n    margin-right: 1px;\n    cursor: pointer;\n    vertical-align: baseline;\n    width: ", ";\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    \n    &:hover {\n      border-color: ", ";\n    }\n  "])), theme.FONT_SIZE(10), theme.COLOR('textMid'), theme.COLOR('light'), theme.UNIT(4.5), theme.UNIT(4.5), theme.COLOR('dark'))
});
var TooltipStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 160px;\n    line-height: 1.35em;\n    text-align: left;\n    padding: ", " !important;\n    border-radius: 0;\n\n    &.show {\n      opacity: 1.0 !important;\n    }\n\n    a {\n      color: ", " !important;\n      text-decoration: underline;\n\n      &:hover {\n        color: ", " !important;\n      }\n    }\n  "], ["\n    width: 160px;\n    line-height: 1.35em;\n    text-align: left;\n    padding: ", " !important;\n    border-radius: 0;\n\n    &.show {\n      opacity: 1.0 !important;\n    }\n\n    a {\n      color: ", " !important;\n      text-decoration: underline;\n\n      &:hover {\n        color: ", " !important;\n      }\n    }\n  "])), theme.UNIT(3), theme.COLOR('light'), theme.COLOR('dark')),
  landscape: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 220px;\n  "], ["\n    width: 220px;\n  "]))),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 310px;\n  "], ["\n    width: 310px;\n  "])))
});
var CitationStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-family: ", ";\n  "], ["\n    font-family: ", ";\n  "])), theme.FONT('serif'))
}); // -------- Components -------->

var My = {
  Container: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Text: styled.sup.attrs(cls.attr('text'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TextStyles),
  Tooltip: styled(ReactTooltip)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), TooltipStyles),
  Citation: styled(CitationCell)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), CitationStyles)
};
/**
 * Creates a small bubble icon which shows the citation for the slug referenced by the `id` prop
 * in a tooltip. This component must be wrapped in an `EntityProvider` which provides a value which is an
 * Entity object (typically a `Page`) with an `embeds` property which itself contains an array of `Citation` entity objects to lookup.
 */

export var CitationReference = function CitationReference(props) {
  var className = props.className,
      children = props.children,
      id = props.id;
  var entity = useEntity();
  var _a = useEmbedsBySlug().citations,
      citations = _a === void 0 ? {} : _a;
  var citation = citations[id] || {
    slug: '',
    name: '',
    type: null
  };

  if (!citation.slug) {
    console.warn("Unable to find citation with slug", id);
  }

  var theme = useTheme();
  var isReady = useReady().isReady;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Text, {
    "data-tip": "",
    "data-for": citation.slug
  }, children), !!citation.slug && isReady && React.createElement(My.Tooltip, {
    backgroundColor: theme.color.textMid,
    delayHide: 300,
    delayShow: 100,
    effect: "solid",
    // overridePosition={() => ({ left: 0, top: 0 })}
    clickable: true,
    wrapper: "span",
    id: citation.slug
  }, isReady && React.createElement(My.Citation, {
    entity: citation
  })));
};
CitationReference.defaultProps = CitationReferenceDefaultProps;
CitationReference.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;